import {
  listIndustries,
  listSuperSectors,
  listSectors,
  listSubSectors,
} from './list';
import {
  detailIndustry,
  detailSuperSector,
  detailSector,
  detailSubSector,
} from './detail';
import {
  createIndustry,
  createSuperSector,
  createSector,
  createSubSector,
} from './create';
import {
  editIndustry,
  editSuperSector,
  editSector,
  editSubSector,
} from './edit';
import {
  deleteIndustry,
  deleteSuperSector,
  deleteSector,
  deleteSubSector,
} from './delete';

export const IndustryApiCall = {
  list: listIndustries,
  detail: detailIndustry,
  create: createIndustry,
  edit: editIndustry,
  delete: deleteIndustry,
};

export const SuperSectorApiCall = {
  list: listSuperSectors,
  detail: detailSuperSector,
  create: createSuperSector,
  edit: editSuperSector,
  delete: deleteSuperSector,
};

export const SectorApiCall = {
  list: listSectors,
  detail: detailSector,
  create: createSector,
  edit: editSector,
  delete: deleteSector,
};

export const SubSectorApiCall = {
  list: listSubSectors,
  detail: detailSubSector,
  create: createSubSector,
  edit: editSubSector,
  delete: deleteSubSector,
};
